import styled from 'styled-components';

const Badge = styled.span`
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  
  ${({ category }) => {
    switch (category?.toLowerCase()) {
      case 'sales':
        return 'background-color: #E6F4F1; color: #2A9D8F;';
      case 'inventory':
        return 'background-color: #E6EFFE; color: #2F80ED;';
      case 'service':
        return 'background-color: #E7F5FF; color: #2D9CDB;';
      case 'operations':
        return 'background-color: #FFF3DC; color: #F2994A;';
      case 'marketing':
        return 'background-color: #FFE6E6; color: #EB5757;';
      case 'telemetry':
        return 'background-color: #E6F4F1; color: #27AE60;';
      case 'analytics':
        return 'background-color: #F2F2F2; color: #4F4F4F;';
      case 'finance':
        return 'background-color: #E6F4F1; color: #219653;';
      case 'hr':
        return 'background-color: #F3E6FF; color: #9B51E0;';
      default:
        return 'background-color: #F2F2F2; color: #4F4F4F;';
    }
  }}
`;

export const CategoryBadge = ({ category }) => {
  return <Badge category={category}>{category}</Badge>;
};
